import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { LoadingIndicator } from 'components/common';
import {
  UserAttributesFormSettings,
  UserAttributesList,
  UserAttributesLimitedList,
  UserAttributesNotifications
} from '.';

import type { GetUserCustomAttributesRes } from 'shared-types/responses';

const UserAttributes = () => {
  const { user } = useReduxState();

  const { data, loading, updateData } = useApiData<GetUserCustomAttributesRes>({
    url: '/admin/user-custom-attributes'
  });

  const userCustomAttributes = data?.userCustomAttributes || [];

  return (
    <div className="user-attributes">
      {loading ? (
        <LoadingIndicator />
      ) : user?.roles.includes('vuoadmin') ? (
        <>
          <UserAttributesList
            updateData={updateData}
            userCustomAttributes={userCustomAttributes}
          />

          <UserAttributesFormSettings
            updateData={updateData}
            userCustomAttributes={userCustomAttributes}
          />

          <UserAttributesNotifications
            userCustomAttributes={userCustomAttributes}
          />
        </>
      ) : (
        <UserAttributesLimitedList
          userCustomAttributes={userCustomAttributes}
        />
      )}

      <style jsx>{`
        .user-attributes {
          display: flex;
          flex-direction: column;
          gap: 30px;
        }
      `}</style>
    </div>
  );
};

export default UserAttributes;
